import React, { useContext, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { AppContext } from '../../context/AppContext';
import Card from '../common/Card';
import { FaReceipt, FaSpinner } from 'react-icons/fa';
import UpsellComponent from '../upsellComponent';
import { getBoughtItems } from '../../api/vehicleAPI';

const SummaryCard = styled(Card)` padding: 30px; height: fit-content; position: sticky; top: 120px; @media (max-width: ${({ theme }) => theme.breakpoints.lg}) { position: static; }`;
const Title = styled.h2` display: flex; align-items: center; gap: 10px; font-size: 22px; color: ${({ theme }) => theme.colors.primaryDark}; margin-bottom: 25px; `;
const OrderItem = styled.div` display: flex; justify-content: space-between; align-items: center; min-height: 55px; padding: 15px 0; border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray}; font-size: 16px; span:first-child { font-weight: 500; color: ${({ theme }) => theme.colors.gray}; } span:last-child { font-weight: 700; color: ${({ theme }) => theme.colors.dark}; } `;
const OrderTotal = styled(OrderItem)` font-size: 18px; font-weight: 700; border-top: 2px solid ${({ theme }) => theme.colors.primaryLight}; margin-top: 20px; border-bottom: none; span { color: ${({ theme }) => theme.colors.dark}; font-weight: 800; } span:last-child { font-size: 22px; color: ${({ theme }) => theme.colors.primaryDark}; } `;
const spin = keyframes` from { transform: rotate(0deg); } to { transform: rotate(360deg); } `;
const LoadingState = styled.div` display: flex; align-items: center; justify-content: center; gap: 10px; padding: 20px; color: ${({ theme }) => theme.colors.gray}; font-style: italic; svg { animation: ${spin} 1s linear infinite; } `;


const OrderSummaryUpsell = ({ upsellOptions, orderId }) => {
  const { cart } = useContext(AppContext);
  const [itensComprados, setItensComprados] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBoughtItems = async () => {
      setIsLoading(true);
      if (!orderId) {
        setIsLoading(false);
        return;
      }
      try {
        const data = await getBoughtItems(orderId);

        // ==================================================================
        // LÓGICA CORRIGIDA PARA LER A RESPOSTA DO SEU BACKEND
        // ==================================================================
        let boughtIds = [];
        // Verifica se a resposta é uma lista e tem pelo menos um item
        if (Array.isArray(data) && data.length > 0) {
            // Pega o primeiro objeto da lista
            const firstItem = data[0];
            // Verifica se esse objeto tem a propriedade 'produto_id' e se ela não é vazia
            if (firstItem && firstItem.produto_id) {
                // Quebra o texto 'ID1,ID2,ID3' em uma lista ['ID1', 'ID2', 'ID3']
                boughtIds = firstItem.produto_id.split(',')
                    .map(id => id.trim().toUpperCase()); // Limpa espaços e padroniza para maiúsculas
            }
        }
        
        console.log("IDs comprados extraídos da API:", boughtIds);
        setItensComprados(boughtIds);

      } catch (error) {
        console.error("Erro ao buscar itens comprados:", error);
        setItensComprados([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBoughtItems();
  }, [orderId]);

  const blockedIds = ['CONSULTA_DEMO', 'CONSULTA_COMPLETA'].map(id => id.toUpperCase());

  const availableUpsells = (upsellOptions || []).filter(opt => {
    if (!opt || opt.ID == null) return false;
    const optionId = String(opt.ID).toUpperCase();
    return !blockedIds.includes(optionId) && !itensComprados.includes(optionId);
  });
  
  const cartItems = (cart || []).filter(item => {
    if (!item || item.id == null) return false;
    const itemId = String(item.id).toUpperCase();
    return !itensComprados.includes(itemId);
  });

  const totalCartPrice = cartItems.reduce((total, item) => total + (Number(item.price) || 0), 0);

  return (
    <SummaryCard>
      <Title><FaReceipt /> Resumo do Pedido</Title>

      {cartItems.length > 0 ? cartItems.map(item => (
        <OrderItem key={item.id}>
          <span>{item.title}</span>
          <span>+ R$ {Number(item.price).toFixed(2).replace('.', ',')}</span>
        </OrderItem>
      )) : (
        <OrderItem>
            <span>Nenhum item adicional selecionado.</span>
        </OrderItem>
      )}

      <OrderTotal>
        <span>Total Adicional</span>
        <span>R$ {totalCartPrice.toFixed(2).replace('.', ',')}</span>
      </OrderTotal>
      
      {isLoading ? (
        <LoadingState>
            <FaSpinner />
            Carregando opções...
        </LoadingState>
      ) : (
        <UpsellComponent
          title="Informações Adicionais"
          data={availableUpsells}
        />
      )}
    </SummaryCard>
  );
};

export default OrderSummaryUpsell